import { lang } from "src/language/Strings";
import React, { useLayoutEffect, useRef } from "react";
import { LocalStorageKeys } from "src/utils/localStorageKeys";

export default function SearchInput({
  onChange,
}: {
  onChange: (value: string) => void;
}) {
  const element = useRef<HTMLInputElement>(null);

  useLayoutEffect(() => {
    if (element.current) {
      element.current.focus();
    }
  }, []);

  return (
    <div className={`flex items-center w-full`}>
      <div className="relative w-full">
        <input
          type="text"
          className="w-full border-2 p-2  border-Grey2"
          placeholder={lang.search}
          ref={element}
          onChange={(e) => {
            onChange(e.target.value);
          }}
        />
        {element.current?.value && element.current?.value.length > 0 && (
          <button
            onClick={() => {
              if (element.current) {
                element.current.value = "";
                const filter = JSON.parse(
                  localStorage.getItem(LocalStorageKeys.filter) || "{}"
                );
                delete filter.searchText;
                localStorage.setItem(
                  LocalStorageKeys.filter,
                  JSON.stringify(filter)
                );
                onChange("");
              }
            }}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-PrimaryBlack hover:text-Grey4 transition-colors"
            aria-label="Clear search"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
}
